import React from "react";
import { FaTwitter } from "@react-icons/all-files/fa/FaTwitter";
import { FaPinterest } from "@react-icons/all-files/fa/FaPinterest";
import { FaFacebook } from "@react-icons/all-files/fa/FaFacebook";
import { useStaticQuery, graphql } from "gatsby";

function NavSocialExternalLink({ href, children, className }) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={`px-2 py-2 ${className}`}
    >
      {children}
    </a>
  );
}

export default function ShareSocial({
  className = "",
  iconClassName,
  title,
  cover = undefined,
  description = "",
  slug,
}) {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          siteUrl
          facebookAppId
        }
      }
    }
  `);

  var link = encodeURI(data.site.siteMetadata.siteUrl + slug);
  var media = cover
    ? encodeURI(data.site.siteMetadata.siteUrl + cover.publicURL)
    : "";
  title = encodeURI(title);
  description = encodeURI(description);

  return (
    <div className={`flex ${className}`}>
      <NavSocialExternalLink
        key="twitter"
        href={`https://twitter.com/intent/tweet?url=${link}&text=${title}&via=lostwithlydia`}
        className={iconClassName}
      >
        <FaTwitter />
      </NavSocialExternalLink>

      {cover && (
        <NavSocialExternalLink
          key="pinterest"
          href={`https://www.pinterest.com/pin/create/bookmarklet/?url=${link}&media=${media}&is_video=false&description=${description}`}
          className={iconClassName}
        >
          <FaPinterest />
        </NavSocialExternalLink>
      )}

      <NavSocialExternalLink
        key="facebook"
        href={`https://www.facebook.com/dialog/share?app_id=${data.site.siteMetadata.facebookAppId}&href=${link}`}
        className={iconClassName}
      >
        <FaFacebook />
      </NavSocialExternalLink>
    </div>
  );
}
